"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
class Step {
    constructor() {
        this._locked = true;
        this._firstShow = true;
    }
    lock() { this._locked = true; }
    unlock() { this._locked = false; }
    isLocked() { return this._locked; }
    isFirstShow() {
        if (this._firstShow) {
            this._firstShow = false;
            return true;
        }
        return false;
    }
}
exports.Step = Step;
